import angular from 'angular';

import CurrentUser from '../../models/user';
import CurrentCase from '../../models/case';

function ContributorEnable($rootScope, CurrentUser, CurrentCase) {
  return {
    restrict: 'A',
    link: {
      pre: function (scope, element) {
        let isVisitor = () => {
          if (CurrentCase.data.hasOwnProperty('contributors')) {
            // a visitor is not a case contributor or does not have an email
            let isVisitor = CurrentUser.data.hasOwnProperty('email') ?
              !CurrentCase.data.contributors
              .map(contributor => contributor.email)
              .some(email => email === CurrentUser.data.email) : true

            $rootScope.isVisitor = isVisitor;
            return isVisitor

          } else {
            $rootScope.isVisitor = false;
          }
        }

        isVisitor() ?
          element.addClass('contributor-disabled') :
          element.removeClass('contributor-disabled');

        element.bind('click', function (e) {

          if (isVisitor()) {
            e.stopImmediatePropagation();
            e.preventDefault();
            $rootScope.$apply();
            // set a message?
          }
        });
      }
    }
  };
}
ContributorEnable.$inject = ['$rootScope', 'CurrentUser', 'CurrentCase'];

export default angular.module('directives.payment-enable', [
    CurrentUser, CurrentCase
  ])
  .directive('lfContributorEnable', ContributorEnable)
  .name;


// WEBPACK FOOTER //
// ./project/directives/lf-contributor-enable/index.js